<mat-form-field class="default-field-width" [formGroup]="form" [appearance]="appearance || 'fill'">
  <mat-label>{{ 'KEY_INDICATOR.PLACEHOLDER' | translate }}</mat-label>
  <mat-select [formControlName]="controlName">
    <mat-option [value]="KeyIndicatorType.SALES_SQFT">{{ 'KEY_INDICATOR.EST_SALES_SQFT' | translate }}</mat-option>
    <mat-option [value]="KeyIndicatorType.SALES_VOLUME">{{ 'KEY_INDICATOR.EST_SALES_VOLUME' | translate }}</mat-option>
  </mat-select>
</mat-form-field>
